import bioData from '../data/bio.json';

const BioCard = () => {
  return (
    <section className='card p-4 home-card home-panel-card shadow'>
      <div className='card-body'>
        <h2 className='card-title home-panel-title mb-3'>{bioData.title}</h2>
        {bioData.paragraphs.map((paragraph) => (
          <p className='home-bio-paragraph' key={paragraph}>
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};

export default BioCard;
